import React from "react";
import { Modal } from "react-bootstrap";
import PropTypes from "prop-types";
import Canvas from "../canvas/Canvas";

export default function ImageDrawModal({ show, title, image, onClose }) {
    return (
        <Modal
            show={show}
            size="lg"
            onHide={onClose}
            dialogClassName="modal-90w"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title>Eye Draw - {title}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div style={{ height: "70vh", width: "100%", maxWidth: "60vw", margin: "0 auto" }}>
                    <Canvas image={image} />
                </div>
            </Modal.Body>
        </Modal>
    );
}

ImageDrawModal.propTypes = {
    show: PropTypes.bool.isRequired,
    title: PropTypes.string.isRequired,
    image: PropTypes.any.isRequired,
    onClose: PropTypes.func.isRequired,
};
